import get from '@/ajax/compare/get';
import add from '@/ajax/compare/add';
import remove from '@/ajax/compare/remove';
import clear from '@/ajax/compare/clear';

/**
 * @module ajaxAPI/compare
 *
 * @description
 * Ajax-обертки для работы со сравнением
 */

const compare = {
  get,
  add,
  remove,
  clear
};

export default compare;
